const initialState = {
  client: false
};

export function modal(state = initialState, action) {
  const newState = Object.assign({}, state);
  newState[action.key] = !newState[action.key];
  newState.obj = action.obj;
  return newState;
}



// WEBPACK FOOTER //
// ./src/_reducers/modal.reducer.js